import { Search } from 'lucide-react'

export interface NoResultsStateProps {
  onResetFilters?: () => void
}

/**
 * Состояние "ничего не найдено"
 */
export function NoResultsState({ onResetFilters }: NoResultsStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12 text-center animate-in fade-in duration-200">
      <div className="w-12 h-12 rounded-full bg-gray-100 dark:bg-dark-elevated flex items-center justify-center mb-3">
        <Search className="w-5 h-5 text-gray-400" />
      </div>
      
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Ничего не найдено
      </p>
      
      {onResetFilters && (
        <button
          type="button"
          onClick={onResetFilters}
          className="text-sm font-medium text-primary dark:text-primary-light"
        >
          Сбросить фильтры
        </button>
      )}
    </div>
  )
}
